module.exports = __webpack_public_path__ + "static/media/page101_01.4950f8db.jpg";